<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 18 18">
  <g clip-path="url(#a)">
    <path d="M14.85 5.4H10.8V3.15c0-.747-.603-1.35-1.35-1.35h-.9c-.747 0-1.35.603-1.35 1.35V5.4H3.15c-.747 0-1.35.603-1.35 1.35v8.1c0 .747.603 1.35 1.35 1.35h11.7c.747 0 1.35-.603 1.35-1.35v-8.1c0-.747-.603-1.35-1.35-1.35Zm-6.3-2.25h.9v3.6h-.9v-3.6Zm6.3 11.7H3.15v-8.1H7.2c0 .747.603 1.35 1.35 1.35h.9c.747 0 1.35-.603 1.35-1.35h4.05v8.1Z"/>
    <path d="M13.5 9h-2.7v1.35h2.7V9Zm0 2.25h-2.7v1.35h2.7v-1.35Zm-6.75 0a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Zm1.566.774A3.963 3.963 0 0 0 6.75 11.7c-.558 0-1.08.117-1.566.324-.414.18-.684.585-.684 1.044v.432H9v-.432c0-.459-.27-.864-.684-1.044Z"/>
  </g>
  <defs>
    <clipPath id="a">
      <path d="M0 0h18v18H0z"/>
    </clipPath>
  </defs>
</svg>
